
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const itemonplateApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listItemOnPlates: builder.query ({
      query: (params) => `v2/itemonplate/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["ItemOnPlate"]
    }),
    getItemOnPlate: builder.query ({
      query: (itemonplate_id) => `v2/itemonplate/${itemonplate_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["ItemOnPlate"]
    }),

    updateItemOnPlate: builder.mutation ({
      query: ({itemonplate_id, data}) => ({
        url: `v2/itemonplate/${itemonplate_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["ItemOnPlate"]
    }),
    deleteItemOnPlate: builder.mutation ({
      query: (itemonplate_id) => ({
        url: `v2/itemonplate/${itemonplate_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["ItemOnPlate"]
    }),
    createItemOnPlate: builder.mutation ({
      query: (data) => ({
        url: `v2/itemonplate/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ItemOnPlate"]
    }),
  })
})


export const {
  useListItemOnPlatesQuery,
  useLazyListItemOnPlatesQuery,
  useGetItemOnPlateQuery,
  useLazyGetItemOnPlateQuery,

  useUpdateItemOnPlateMutation,
  useDeleteItemOnPlateMutation,
  useCreateItemOnPlateMutation
} = itemonplateApi
